import React, { Component } from 'react';

import { Toolbar } from 'primereact/toolbar';
import { BreadCrumb } from 'primereact/breadcrumb';
import { InputSwitch } from 'primereact/inputswitch';
import moment from 'moment';
//import Navbar from './../navbar';
import { Button } from 'primereact/button';
import SvgViewer from '../../customComponents/svgViewer';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from 'primereact/toast';
import { Checkbox } from 'primereact/checkbox';
import { Menu } from 'primereact/menu';
// import SearchBar from './searchBar';
import Service from '../../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import LoadingComponent from '../../loadingComponent';
import { connect } from 'react-redux';
// import { withRouter } from 'react-router-dom';
// import './styles.scss'
// import UserInfo from './userInfo';
// import CreateUser from './createUser';
import Authentication from '../../session';
import Authorizer, { PERMISSIONS } from '../../session/authorizer';
import { BasicLazyParams, warningDailogInit } from '../../../utile';
import IndividualUsageAnalytics from '../../analytics/usageAnalytics/individualUsageAnalytics';
import { AnalyticsIcon2, LocationMarker, MailIcon, WarningIcon } from '../../svgIcons';
import ReactApexChart from 'react-apexcharts';
import { I18Next } from '../../../internationalization';
import withRouter from '../../lib/withRouter';
import CreateRoute from './createRoute';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import { getBranchesLatest } from '../../../store/actions';
import './menuRouteManagement.scss';
import CreateSpecialRoute from './createSpecialRoute';
import { userAssignedBoards } from '../../../store/selectors/userAssignedBoards';
class MenuRouteManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedUser: null,
            isCreateUser: false,
            dataForAddRoutes: null,
            isShowCreateForm: false,
            isShowSpecialCreateForm: false,
            editUser: null,
            filterData: null,
            totalRecords: 0,
            globalSearch: '',
            lazyParams: BasicLazyParams
        };

        this.service = new Service();
    }

    componentDidMount() {
        // this.props.getBranchesLatest(true);
    }

    onCancel = () => {
        this.setState({
            isShowCreateForm: false,
            isShowSpecialCreateForm: false
        });
    };

    getRoutesData = async () => {
        const academicYear = localStorage.getItem('userAcademicYear');
        this.setState({ isLoading: true });
        let url = `${baseUrlAdmin}/transport-route/get-routes?academicYear=${academicYear}`;
        let payload = {
            branchId: this.state.branchId,
            academicYear: academicYear
        };
        try {
            const res = await this.service.post(url, payload, true);
            if (res?.res?.status && res.status) {
                this.setState({ users: res?.res?.data?.routeData, isLoading: false });
            } else {
                this.setState({ isLoading: false, branchId: null });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occured', life: 3000 });
            }
        } catch (e) {
            this.setState({ isLoading: false, branchId: null });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e, life: 3000 });
        }
    };

    addRoute = (rowData) => {
        // Check if it's a special route and open the appropriate form
        if (rowData?.isSpecialRoute) {
            this.setState({
                isShowSpecialCreateForm: true,
                dataForAddRoutes: rowData
            });
        } else {
            this.setState({
                isShowCreateForm: true,
                dataForAddRoutes: rowData
            });
        }
    };
    render() {
        return (
            <>
                <div className="flex justify-content-between  align-items-center lg:mt-4 md:mt-6 mb-2 mx-5">
                    <div className="col-span-1 ">
                        <p className="add-vehicle-field-label">
                            Branch<span className="ma-required">*</span>
                        </p>
                        <div className="flex justify-content-start  align-items-center">
                            <ClassetDropdown
                                // icon={<MailIcon />}
                                optionLabel="name"
                                optionValue="key"
                                value={this.state.branchId}
                                options={this.props.branchData}
                                onChange={(e) =>
                                    this.setState(
                                        {
                                            branchId: e.target.value
                                        },
                                        () => this.getRoutesData()
                                    )
                                }
                                className="w-full"
                                placeholder={
                                    <div className="flex justify-content-start  align-items-center">
                                        <span className="">Select Branch</span>
                                    </div>
                                }
                            />
                        </div>
                    </div>
                    <div>
                        <Authorizer permId={PERMISSIONS.ADD_SPECIAL_ROUTE}>
                            <Button
                                icon={'pi pi-plus-circle text-lg px-1 '}
                                className="add-special-route-btn pl-4"
                                onClick={() => {
                                    this.setState({ isShowSpecialCreateForm: true, dataForAddRoutes: null });
                                }}
                            >
                                Add Special Route
                            </Button>
                        </Authorizer>
                        <Authorizer permId={PERMISSIONS.ADD_ROUTE}>
                            <Button
                                icon={'pi pi-plus-circle text-lg px-1 '}
                                className="add-vehicle-btn pl-4 mx-2"
                                onClick={() => {
                                    this.setState({ isShowCreateForm: true, dataForAddRoutes: null });
                                }}
                            >
                                Add Route
                            </Button>
                        </Authorizer>
                    </div>
                </div>

                <div className="card datatable-crud-demo ma-m30  m-2">
                    <DataTable
                        ref={(el) => (this.dt = el)}
                        className="dataTableValuesText"
                        columnResizeMode="expand"
                        value={this.state.users}
                        dataKey="id"
                        paginator
                        responsiveLayout="scroll"
                        totalRecords={this.state?.totalRecords}
                        rows={10}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        globalFilter={this.state.globalFilter}
                        header={''}
                    >
                        <Column
                            style={{ width: '15rem', height: '6rem' }}
                            alignHeader={'center'}
                            sortable
                            headerClassName="text-color-secondary"
                            bodyClassName="text-center"
                            header="S.No."
                            className="datatable-cell"
                            body={(rowData, index) => {
                                return (
                                    <>
                                        <p>{this.state.lazyParams.page * this.state.lazyParams.rows + index.rowIndex + 1}</p>
                                    </>
                                );
                            }}
                        />

                        <Column style={{ width: '15rem', height: '6rem' }} alignHeader={'center'} sortable headerClassName="text-color-secondary" bodyClassName="text-center" filterField="routeName" field="routeName" header="Route Name" />
                        <Column style={{ width: '15rem', height: '6rem' }} alignHeader={'center'} sortable headerClassName="text-color-secondary" bodyClassName="text-center" filterField="totalStops" field="totalStops" header="Total Stops" />

                        <Column
                            style={{ width: '15rem', height: '6rem' }}
                            alignHeader={'center'}
                            sortable
                            headerClassName="text-color-secondary"
                            bodyClassName="text-center"
                            filterField="startLocation"
                            className=""
                            field="startPoint"
                            header="Start Location"
                        />
                        <Column
                            style={{ width: '15rem', height: '6rem' }}
                            alignHeader={'center'}
                            sortable
                            headerClassName="text-color-secondary"
                            bodyClassName="text-center"
                            filterField="endLocation"
                            className=""
                            field="endPoint"
                            header="End Location"
                        />
                        <Column
                            className=" "
                            alignHeader={'center'}
                            bodyClassName="text-center"
                            header="Add Stops"
                            body={(rowData, { rowIndex }) => {
                                return (
                                    <>
                                        <div className="flex justify-content-center align-items-center">
                                            <Authorizer permId={PERMISSIONS.ADD_STOPS}>
                                                <span style={{ cursor: 'pointer' }} onClick={() => this.addRoute(rowData)} data-pr-tooltip="Add Stops" data-pr-position="bottom" className={`yh${rowIndex}`}>
                                                    <LocationMarker height={25} width={25} className="ma-icon-svg ma-pointer mr-1 " />
                                                </span>
                                                <Tooltip className="table-li-tooltip2" autoHide={false} target={`.yh${rowIndex}`} />
                                            </Authorizer>
                                        </div>
                                    </>
                                );
                            }}
                        ></Column>
                    </DataTable>
                </div>

                <Dialog
                    blockScroll={true}
                    visible={this.state.isShowCreateForm}
                    draggable={false}
                    closeOnEscape={false}
                    className="ma-alert-box"
                    dismissableMask={false}
                    closable={true}
                    style={{
                        width: '90%',
                        height: 'auto',
                        maxHeight: '90%',
                        margin: '0 auto'
                    }}
                    header={() => {
                        return <h2 className="transport-header py-2">{'Add'} Route</h2>;
                    }}
                    onHide={() => {
                        this.setState({
                            isShowCreateForm: false,
                            newPassword: null
                        });
                    }}
                >
                    <div className="">
                        <CreateRoute onCancel={this.onCancel} getRoutesData={this.getRoutesData} dataForAddRoutes={this.state.dataForAddRoutes} toastMessage={this.toast} />
                    </div>
                </Dialog>

                <Dialog
                    blockScroll={true}
                    visible={this.state.isShowSpecialCreateForm}
                    draggable={false}
                    closeOnEscape={false}
                    className="ma-alert-box"
                    dismissableMask={false}
                    closable={true}
                    style={{
                        width: '90%',
                        height: 'auto',
                        maxHeight: '90%',
                        margin: '0 auto'
                    }}
                    header={() => {
                        return <h2 className="transport-header py-2">{'Add Special'} Route</h2>;
                    }}
                    onHide={() => {
                        this.setState({
                            isShowSpecialCreateForm: false,
                            newPassword: null
                        });
                    }}
                >
                    <div className="">
                        <CreateSpecialRoute onCancel={this.onCancel} getRoutesData={this.getRoutesData} dataForAddRoutes={this.state.dataForAddRoutes} toastMessage={this.toast} />
                    </div>
                </Dialog>

                {this.state.isLoading && (
                    <>
                        <LoadingComponent />
                    </>
                )}
                <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoardsWithoutMeluha'),
    isLoading: state.boardsData.loading,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._idF
});
export default connect(mapStateToProps, {
    getBranchesLatest
})(Authentication(withRouter(MenuRouteManagement)));
